import OhsUserLocalServices from 'user/OhsUserLocalServices';
import OhsRecordFieldType from 'global-services/constants/record-field/OhsRecordFieldType';
import { getModuleName } from 'user/OhsUserServices';
import { ModuleType } from 'global-services/constants/OhsObject';

const user = OhsUserLocalServices.getLocalOhsUser();

export const OhsReferenceRecordField = new OhsRecordFieldType('reference', 'Reference');

export const OhsDateReportedRecordField = new OhsRecordFieldType('dateReported', 'Date Reported');

export const OhsDateOccurredRecordField = new OhsRecordFieldType('dateOccurred', 'Date of ');

export const OhsTimeOccurredRecordField = new OhsRecordFieldType('timeOccurred', 'Time of ');

export const OhsPersonReportingRecordField = new OhsRecordFieldType(
  'personReporting',
  'Person Reporting the'
);

export const OhsLocationRecordField = new OhsRecordFieldType('location', 'Location');

export const OhsLocationOtherRecordField = new OhsRecordFieldType(
  'locationOther',
  'Other Location of'
);

export const OhsPropertyOrEnvDamageField = new OhsRecordFieldType(
  'propOrEnvDamage',
  'Property and/or Environmental Damage'
);

export const OhsPropertyOrEnvDamageCusvalsField = new OhsRecordFieldType(
  'propOrEnvDamageCusvals',
  'Property and/or Environmental Damage Cusvals'
);

export const OhsPropertyOrEnvDamageDescriptionField = new OhsRecordFieldType(
  'propOrEnvDamageDescription',
  'Details of the Damage'
);

export const OhsDescriptionField = new OhsRecordFieldType('description', 'Describe what Happened');

export const OhsInjuredPersonRoleField = new OhsRecordFieldType(
  'injuredPersonRole',
  'Injured Person Role'
);

export const OhsInjuredPersonRoleOtherField = new OhsRecordFieldType(
  'injuredPersonRoleOther',
  'Description of other type'
);

export const OhsInjuredPersonLinksField = new OhsRecordFieldType(
  'injuredPersonLinks',
  'Person Name (Auto Suggest)'
);

export const OhsInjuredPersonNameField = new OhsRecordFieldType(
  'injuredPersonName',
  'Name of Injured Person'
);

export const OhsInjuredPersonPhoneField = new OhsRecordFieldType(
  'injuredPersonPhone',
  'Mobile Number of Injured Person'
);

export const OhsInjuredBodyPartsField = new OhsRecordFieldType('injuredBodyParts', 'Injury Parts');

export const OhsInjuryDescriptionField = new OhsRecordFieldType(
  'injuryDescription',
  'Injury Description'
);

export const OhsBodyPartField = new OhsRecordFieldType('bodyPart', 'Injured Part');

export const OhsBodyPartOtherField = new OhsRecordFieldType('bodyPartOther', 'Other Injured Part');

export const OhsInjuryTypeField = new OhsRecordFieldType('injury', 'Injury Type');

export const OhsInjuryTypeOtherField = new OhsRecordFieldType('injuryOther', 'Other Injury Type');

export const OhsCommentField = new OhsRecordFieldType('comment', 'Comment');

export const OhsWitnessNameField = new OhsRecordFieldType('witnessName', 'Name of Witness');

export const OhsWitnessPhoneField = new OhsRecordFieldType(
  'witnessPhone',
  'Mobile Number of Witness'
);

export const OhsControlReviewedField = new OhsRecordFieldType(
  'controlReviewed',
  'Were the established controls reviewed as part of this investigation?'
);
export const OhsControlReviewedOtherField = new OhsRecordFieldType(
  'controlReviewedOther',
  'Control review details'
);
export const OhsControlReviewCusvalsField = new OhsRecordFieldType(
  'controlReviewCusvals',
  'Control review cusval'
);
export const OhsChangeNotesField = new OhsRecordFieldType(
  'changeNotes',
  'What changes can be made to prevent reoccurrence?'
);
export const OhsChangeImplementedField = new OhsRecordFieldType(
  'changeImplemented',
  'Have these changes been implemented into the business?'
);
export const OhsControlLevelField = new OhsRecordFieldType(
  'controlLevel',
  'What was the highest level of control achieved?'
);
export const OhsControlLevelOtherField = new OhsRecordFieldType(
  'controlLevelOther',
  'Highest level of control achieved'
);
export const OhsControlLevelCusvalsField = new OhsRecordFieldType(
  'controlLevelCusvals',
  'Control level cusval'
);
export const OhsLostTimeInjuryField = new OhsRecordFieldType(
  'lostTimeInjury',
  `Was this ${user?.configs.incident?.TITLE} an LTI (lost-time injury)?`
);
export const OhsHazardCategoryField = new OhsRecordFieldType(
  'hazardCategory',
  `What hazard is best associated with the ${user?.configs.incident?.TITLE}?`
);
export const OhsHazardCategoryOtherField = new OhsRecordFieldType(
  'hazardCategoryOther',
  'Describe the hazard'
);
export const OhsHazardCategoryCusvalsField = new OhsRecordFieldType(
  'hazardCategoryCusvals',
  'Hazard Category Cusval'
);
export const OhsSeverityField = new OhsRecordFieldType(
  'severity',
  `${getModuleName(user?.configs, ModuleType.Incident)} Severity`
);
export const OhsSeverityCusvalsField = new OhsRecordFieldType(
  'severityCusvals',
  `${getModuleName(user?.configs, ModuleType.Incident)} Severity`
);
export const OhsExternalBodiesNotifiedFieldYesNo = new OhsRecordFieldType(
  'externalBodiesNotifiedYesNo',
  'Is external notification required?'
);
export const OhsExternalBodiesNotifiedField = new OhsRecordFieldType(
  'externalBodiesNotified',
  'Add details of external bodies notified'
);
export const OhsActionLinksRecordField = new OhsRecordFieldType(
  'links',
  `${user?.configs?.action?.TITLE || 'Action'}`
);

export const OhsLocationCusvalsField = new OhsRecordFieldType(
  'locationCusvals',
  'Location Custom Details'
);

export const OhsInjuredPersonRoleCusvalsField = new OhsRecordFieldType(
  'injuredPersonRoleCusvals',
  'Injured Person Role Custom Details'
);
